import { render, staticRenderFns } from "./CartMealRow.vue?vue&type=template&id=2284f07c"
import script from "./CartMealRow.vue?vue&type=script&lang=js"
export * from "./CartMealRow.vue?vue&type=script&lang=js"
import style0 from "./CartMealRow.vue?vue&type=style&index=0&id=2284f07c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports